import { IListScheduledCollect } from '../../../../types/ListCollectData';
import GeneralCollectCard from '../../../Cards/GeneralCollectCard';
import { ListCardCollects } from '../styles';

export const ListCardsScheduledCollect = ({ data }: IListScheduledCollect) => {
  return (
    <ListCardCollects>
      {data.map((collect, key) => {
        return (
          <GeneralCollectCard
            collect={collect}
            type="programada"
            {...{ key }}
          />
        );
      })}
    </ListCardCollects>
  );
};
